import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';

const OWNER_NAV = [
  ['/', 'Overview'],
  ['/students', 'Students'],
  ['/promotions', 'Promotions'],
  ['/staff', 'Instructors'],
  ['/curriculum', 'Curriculum'],
  ['/videos', 'Videos'],
  ['/approvals', 'Grading history'],
  ['/reports', 'Progress reports'],
  ['/audit', 'Audit log'],
  ['/settings', 'Branding & settings'],
] as const;

const INSTRUCTOR_NAV = [
  ['/students', 'Students'],
  ['/promotions', 'Promotions'],
  ['/approvals', 'Grading history'],
] as const;

export function Layout() {
  const { user, settings } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  // On phones the navigation collapses behind a menu button; it closes after every navigation.
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => setMenuOpen(false), [location.pathname]);
  const nav = user?.role === 'owner' ? OWNER_NAV : INSTRUCTOR_NAV;
  const current = nav.find(([to]) =>
    to === '/' ? location.pathname === '/' : location.pathname.startsWith(to),
  );

  return (
    <div className="shell">
      <nav className={`sidebar ${menuOpen ? 'open' : ''}`} aria-label="Main">
        <div className="topbar">
          <div className="brand">
            {settings?.logoUrl ? (
              <img src={settings.logoUrl} alt="" />
            ) : (
              <span className="mark" aria-hidden="true">
                {(settings?.shortName ?? 'C').slice(0, 1)}
              </span>
            )}
            <span className="name">
              {settings?.shortName ?? 'Curriculum'}
              <small>Admin</small>
            </span>
          </div>
          <span className="current-page">{current?.[1]}</span>
          <button
            type="button"
            className="menu-toggle"
            aria-expanded={menuOpen}
            aria-controls="main-nav-links"
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? 'Close' : 'Menu'}
          </button>
        </div>
        <div className="nav-links" id="main-nav-links">
          {nav.map(([to, label]) => (
            <NavLink key={to} to={to} end={to === '/'}>
              {label}
            </NavLink>
          ))}
          <div className="spacer" />
          <div className="who">
            {user?.name}
            <span className="role">{user?.role}</span>
          </div>
          <button
            type="button"
            className="btn small"
            onClick={async () => {
              await api.logout();
              navigate('/login');
            }}
          >
            Sign out
          </button>
        </div>
      </nav>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
